import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { MinimizedDialog, MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';
import { Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonModule } from '@angular/common';
@AutoUnsubscribe()
@Component({
    selector: 'manage-mx-taskbar',
    templateUrl: './manage-mx-taskbar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule
    ]
})
export class ManageMxTaskbarComponent {
  minimizedWidth = 250;
  private subscription!: Subscription;
  minimizedDialogs: MinimizedDialog[] = [];
  // minimizedDialogs = this.mxTaskbarService.getMinimizedDialogs();

  private mxTaskbarService = inject(MxTaskbarService);
  private cd = inject(ChangeDetectorRef);


  ngOnInit() {
    // eslint-disable-next-line eslint-rules/no-unmanaged-subscriptions
    this.subscription = this.mxTaskbarService.minimizedDialogs$.subscribe((dialogs) => {
      this.minimizedDialogs = dialogs;
      this.cd.detectChanges();
    });
  }

  ngOnChanges() {
    this.updateMinimizedWidth();
  }

  maximizeMxDialog(dialog: any) {
    this.mxTaskbarService.maximizeMxDialog(dialog.ref, dialog.dialogId);
  }

  updateMinimizedWidth() {
    const totalDialogs = this.minimizedDialogs.length;
    const availableWidth = window.innerWidth;
    this.minimizedWidth = Math.min(250, Math.floor(availableWidth / totalDialogs));
    this.cd.detectChanges();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
